import { Gift, CreditCard, Gamepad2, Headphones, Smartphone, ShieldCheck } from "lucide-react";

const criteria = [
  {
    number: "1",
    icon: Gift,
    title: "Bonusy a promoakce",
    text: "Uvítací bonusy, free spiny, cashback a věrnostní programy. Skvělý způsob, jak začít hrát s dodatečnými prostředky.",
  },
  {
    number: "2",
    icon: CreditCard,
    title: "Platební metody",
    text: "Karty, e-peněženky, mobilní platby i kryptoměny. Rychlé a bezpečné vklady a výběry pro české hráče.",
  },
  {
    number: "3",
    icon: ShieldCheck,
    title: "Bezpečnost a licence",
    text: "Ověřujeme platné licence, šifrování dat a férové podmínky. Doporučujeme pouze kasina s prokázanou důvěryhodností.",
  },
  {
    number: "4",
    icon: Gamepad2,
    title: "Výběr her",
    text: "Stovky slotů, stolní hry, live casino a další žánry. Hodnotíme rozmanitost i kvalitu herních poskytovatelů.",
  },
  {
    number: "5",
    icon: Headphones,
    title: "Zákaznická podpora",
    text: "Live chat, e-mail a podpora 24/7. Rychlá reakce v kritickém okamžiku je klíčová pro důvěryhodnou platformu.",
  },
  {
    number: "6",
    icon: Smartphone,
    title: "Mobilní kompatibilita",
    text: "Kasino přizpůsobené pro chytré telefony s mobilní verzí webu i samostatnými aplikacemi pro iOS a Android.",
  },
];

export function DecisionGuide() {
  return (
    <section id="pruvodce" className="py-16 bg-white" data-testid="section-decision-guide">
      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-12 xl:px-16">
        <div className="mb-10">
          <h2 className="text-3xl font-black text-gray-900 mb-3">
            Pomáháme vám vybrat casino online CZ, které vám bude vyhovovat
          </h2>
          <p className="text-gray-600 leading-relaxed max-w-3xl">
            Každý hráč je jedinečný – někomu záleží na bonusech, jinému na pohodlných platebních metodách nebo mobilní verzi webu. V této části vám řekneme, na co se zaměřit při výběru best online casino, aby splnilo vaše očekávání a styl hraní.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {criteria.map((item) => (
            <div
              key={item.number}
              className="p-5 rounded-xl border border-gray-100 bg-white hover-elevate cursor-default"
              data-testid={`criterion-${item.number}`}
            >
              <div className="flex items-center gap-3 mb-3">
                <div
                  className="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0"
                  style={{ background: "linear-gradient(135deg, #003da5, #0060e6)" }}
                >
                  <item.icon className="w-5 h-5 text-white" />
                </div>
              </div>
              <h3 className="font-bold text-gray-900 text-sm mb-2 leading-normal">{item.title}</h3>
              <p className="text-gray-500 text-xs leading-relaxed">{item.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
